import React from 'react';
import PropTypes from 'prop-types';
import {
  PageBlock,
  PageBlockHeader,
  PageBlockContent,
  PageBlockCaption
} from 'theme/components/Layout/Layout';
import OfficePageList from '../OfficePageList/OfficePageList';
import { groupByCity as groupOfficesByCity } from 'redux/models/offices/model';

const OfficePageContentMain = ({ selectedOffice, offices }) => {
  const officesGroupedByCity = React.useMemo(() => groupOfficesByCity(offices), [offices]);
  return (
    <PageBlock>
      <PageBlockHeader>
        <PageBlockCaption>
          Головная компания
        </PageBlockCaption>
      </PageBlockHeader>
      <PageBlockContent>
        <OfficePageList
          selectedOffice={selectedOffice}
          offices={officesGroupedByCity}
        />
      </PageBlockContent>
    </PageBlock>
  );
};

OfficePageContentMain.propTypes = {
  selectedOffice: PropTypes.number,
  offices: PropTypes.array
};

export default OfficePageContentMain;
